import React from 'react'
import {NavLink, NavLinkProps} from 'react-router-dom'
import {Box, BoxProps, useTheme} from '@chakra-ui/react'

export default function PageNavigationItem(props: NavLinkProps & BoxProps) {
  const {colors} = useTheme()
  const asProps = {as: NavLink}

  return (
    <Box
      {...props}
      {...asProps}
      alignItems="center"
      borderBottomColor="transparent"
      borderBottomWidth="2px"
      color="gray.500"
      d="flex"
      fontSize="sm"
      h={12}
      pt="2px"
      px={2}
      _hover={{color: `gray.700`}}
      css={{
        '&[aria-current="page"]': {
          borderBottomColor: colors.green[500],
          color: colors.gray[900],
        },
      }}
    />
  )
}
